import { CLOSE_NOTIFICATION, ERR, SHOW_NOTIFICATION } from './actionTypes';

export const error = (message, err, dispatch) => {
  console.error(message, err);
  dispatch({
    type: ERR,
    message,
    err
  });
};

export const getCSRFToken = () => {
  return dispatch => {
    fetch('/api/auth/csrf')
      .then(response => {
        if (response.ok) {
          return response
            .text()
            .then(token => {
              dispatch({
                type: 'SET_CSRF_TOKEN',
                token
              });
            })
            .catch(err => {
              return error('Failed to extract CSRF token', err, dispatch);
            });
        } else {
          return error('Failed to retrieve CSRF token [1]', response, dispatch);
        }
      })
      .catch(err => {
        return error('Failed to retrieve CSRF token [2]', err, dispatch);
      });
  };
};

export const showNotification = (message, color) => dispatch => {
  dispatch({
    type: SHOW_NOTIFICATION,
    message,
    color
  });
};

export const closeNotification = () => dispatch => {
  dispatch({
    type: CLOSE_NOTIFICATION
  });
};



// WEBPACK FOOTER //
// ./src/store/appActions.js